export default __webpack_public_path__ + "static/media/pasteurlab-gray.0148a985.webp";